<template lang="pug">
  .featured-categories
    template(v-if="isMobile")
      flickity(ref="mobileFeaturedCategoriesSlider" :options="flickityOptions")
        featured-categories-tile(
          v-for="(category, index) in categories"
          :key="index"
          :index="index"
          :class="`featured-categories-tile__${index}`" 
          :category="category"
        )
    template(v-else)
      featured-categories-tile(
        v-for="(category, index) in categories"
        :key="index"
        :index="index"
        :class="`featured-categories-tile__${index + 1}`" 
        :category="category"
      )

</template>

<script>
  import Flickity from 'vue-flickity';
  import FeaturedCategoriesTile from 'scripts/components/sections/FeaturedCategoriesTile.vue';

  export default {
    name: 'FeatureCategories',
    components: {
      FeaturedCategoriesTile,
      Flickity,
    },
    props: {
      categories: Array
    },
    data() {
      return {
        flickityOptions: {
          pageDots: true,
          autoPlay: false,
          prevNextButtons: false,
          cellAlign: 'left'
        }
      }
    },
    computed: {
      isMobile () {
        return ['mobile', 'tablet'].includes(this.$mq);
      },
    }
  }
</script>

<style scoped lang="scss">
</style>